'use client';

import { useEffect } from 'react';

// 채널톡 타입 정의
declare global {
  interface Window {
    ChannelIO: any;
    ChannelIOInitialized: boolean;
  }
}

const CHANNEL_PLUGIN_KEY = "c0c538d2-9fec-4cbf-b96f-825b209fa745";

export default function ChannelTalk() {
  useEffect(() => {
    // 채널톡 초기화 코드 (공식 코드에서 직접 가져옴)
    (function() {
      if (typeof window === 'undefined') return;

      // 이미 초기화된 경우 건너뜀
      if (window.ChannelIOInitialized === true) return;

      // 채널톡 부트스트래핑 코드
      var w = window;
      if (w.ChannelIO) return;
      
      // 글로벌 ChannelIO 함수 정의
      var ch: any = function() {
        ch.c?.(arguments);
      };
      ch.q = [];
      ch.c = function(args: any) {
        ch.q?.push(args);
      };
      w.ChannelIO = ch;
      
      // 채널톡 스크립트 로드
      function loadScript() {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
        
        // 스크립트 로드 후 채널톡 초기화
        s.onload = function() {
          window.ChannelIOInitialized = true;
          window.ChannelIO('boot', {
            "pluginKey": CHANNEL_PLUGIN_KEY,
            "hideDefaultLauncher": false,
            "language": "ko"
          });
          console.log('ChannelTalk initialized successfully');
        };
        
        var x = document.getElementsByTagName('script')[0];
        if (x && x.parentNode) {
          x.parentNode.insertBefore(s, x);
        } else {
          document.head.appendChild(s);
        }
      }
      
      // 페이지 로드 상태에 따라 스크립트 로드 시점 결정
      if (document.readyState === 'complete') {
        loadScript();
      } else {
        w.addEventListener('load', loadScript);
      }

      // 초기화 플래그 설정
      w.ChannelIOInitialized = false;
    })();

    // 컴포넌트 언마운트 시 채널톡 정리
    return () => {
      if (typeof window !== 'undefined' && window.ChannelIO && window.ChannelIOInitialized) {
        try {
          window.ChannelIO('shutdown');
        } catch (e) {
          console.error('Error shutting down ChannelIO:', e);
        }
      }
    };
  }, []);

  return null;
}
